import { create, read } from '@/api/rest';

const project = {
  projectStats: async (options) =>
    await read('/project/projects-stats?' + options.toString()),

  profileProjects: async (params) =>
    await read('/project/profile-projects?' + params.toString()),

  export: async (data) => await create('/project/export', data),
};

export default project;
